import ingealimentosApi, { getDomain } from '../../services/ingealimentosApi'

export const getDownloadTokens = params => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get('/download_tokens', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getDownloadToken = (id, params) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get(`/download_tokens/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeDownloadToken = data => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.post('/download_tokens', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateDownloadToken = (id, data) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.put(`/download_tokens/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteDownloadToken = id => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.delete(`/download_tokens/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const searchDownloadTokens = async (term, token) => (
	fetch( getDomain()+`/download_tokens?filter[name]=${term}`, {
		headers: {'Authorization': `Bearer ${token}`}
	})
		.then((response) => response.json())
		.then((res) =>
			res.data.map(item => ({
				label: item.name,
				value: item.id,
			})),
		)
)